const STORAGE_KEY = 'rm.utilization.highlightedRows';

/** Return the current set of highlighted row IDs (as strings) from localStorage. */
export function getHighlightedIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return new Set(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set();
  }
}

function persist(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(ids)));
  } catch {}
}

/**
 * Toggle the highlighted state of a row ID.
 * Returns the updated Set of highlighted IDs.
 */
export function toggleHighlight(id) {
  const ids = getHighlightedIds();
  const key = String(id);
  if (ids.has(key)) {
    ids.delete(key);
  } else {
    ids.add(key);
  }
  persist(ids);
  return new Set(ids);
}

/**
 * Remove all highlights and return an empty Set.
 */
export function clearHighlights() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
  return new Set();
}

// ── Color-rule highlight cache ────────────────────────────────────────────────

const COLOR_RULES_KEY = 'rm.utilization.colorRules';
const SHOW_ONLY_KEY = 'rm.utilization.showOnlyHighlighted';

/** Return saved color rules as an array of { id, contains, color }. */
export function getColorRules() {
  try {
    const raw = localStorage.getItem(COLOR_RULES_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

/** Persist and return the given rules array. */
export function saveColorRules(rules) {
  try {
    localStorage.setItem(COLOR_RULES_KEY, JSON.stringify(rules));
  } catch {}
}

/** Return whether the user has opted to show only highlighted rows. */
export function getShowOnlyHighlighted() {
  try {
    return localStorage.getItem(SHOW_ONLY_KEY) === 'true';
  } catch {
    return false;
  }
}

/** Persist the show-only-highlighted preference. */
export function saveShowOnlyHighlighted(val) {
  try {
    localStorage.setItem(SHOW_ONLY_KEY, val ? 'true' : 'false');
  } catch {}
}
